// Release label shown in the app footer. Bump with each release.
export const APP_VERSION = 'CCOS v4.36.0';
